// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type RemindersAddResponse = SlackAPIResponse & {
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  reminder?: Reminder;
  response_metadata?: ResponseMetadata;
};

export interface Reminder {
  complete_ts?: number;
  creator?: string;
  id?: string;
  recurring?: boolean;
  text?: string;
  time?: number;
  user?: string;
}

export interface ResponseMetadata {
  messages?: string[];
}
